export default {
  primary: {
    dark: "#000",
    normal: "#1C1C1C",
    light: "#353535"
  },
  secondary: {
    dark: "#7F7F7F",
    normal: "#E5E5E5",
    light: "#FFF"
  },
  accent: {
    dark: "#0E4040",
    normal: "#1C7F7F",
    light: "#32E6E6"
  },
  rede: {
    normal: "#FF7A00",
    light: "#FFF600"
  },
  profile: {
    normal: "#1C7F7F",
    light: "#FFFFFF"
  },
  background: {
    dark: "#E5E5E5",
    normal: "#FFF"
  },
  text: {
    dark: "#0E4040",
    normal: "#1C7F7F",
    light: "#32E6E6"
  },
  permissionFields: {
    dark: "#000",
    normal: "#1C1C1C",
    light: "#353535"
  },
  checkbox: {
    normal: "#1C7F7F"
  },
  link: {
    dark: "#0E4040",
    normal: "#1C7F7F"
  },
  notification: {
    dark: "#32E6E6",
    normal: "#FFF",
    light: "#32E6E6"
  },
  button: {
    primary: "#1C1C1C",
    secondary: "#1C7F7F",
    accent: "#1C7F7F"
  },
  switch: {
    primary: "#1C7F7F"
  }
};



// WEBPACK FOOTER //
// ./src/assets/colors/mhi/index.js